import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {Object}
 */
const defaultProps = {
    viewBoxSize: 24
}

/**
 * SVG QR code icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <QRCodeIcon width={12} />
 */
const QRCodeIcon = props => (
    <SvgIcon {...props}>
        <path
            d={`M19 5V9H15V5H19ZM19 3H15C13.9 3 13 3.9 13 5V9C13 10.1 13.9 11 15 11H19C20.1 11 21 10.1 21 9V5C21
            3.9 20.1 3 19 3ZM15 13.5C15 13.23 14.77 13 14.5 13H13.5C13.23 13 13 13.23 13 13.5V14.5C13 14.77
            13.23 15 13.5 15H14.5C14.77 15 15 14.77 15 14.5V13.5ZM19 13.5C19 13.23 18.77 13 18.5 13H17.5C17.23
            13 17 13.23 17 13.5V14.5C17 14.77 17.23 15 17.5 15H18.5C18.77 15 19 14.77 19 14.5V13.5ZM15 17.5C15
            17.23 14.77 17 14.5 17H13.5C13.23 17 13 17.23 13 17.5V18.5C13 18.77 13.23 19 13.5 19H14.5C14.77 19
            15 18.77 15 18.5V17.5ZM19 17.5C19 17.23 18.77 17 18.5 17H17.5C17.23 17 17 17.23 17 17.5V18.5C17 18.77
            17.23 19 17.5 19H18.5C18.77 19 19 18.77 19 18.5V17.5ZM17 19.5C17 19.23 16.77 19 16.5 19H15.5C15.23 19
            15 19.23 15 19.5V20.5C15 20.77 15.23 21 15.5 21H16.5C16.77 21 17 20.77 17 20.5V19.5ZM21 19.5C21 19.23
            20.77 19 20.5 19H19.5C19.23 19 19 19.23 19 19.5V20.5C19 20.77 19.23 21 19.5 21H20.5C20.77 21 21 20.77
            21 20.5V19.5ZM17 15.5C17 15.23 16.77 15 16.5 15H15.5C15.23 15 15 15.23 15 15.5V16.5C15 16.77 15.23 17
            15.5 17H16.5C16.77 17 17 16.77 17 16.5V15.5ZM21 15.5C21 15.23 20.77 15 20.5 15H19.5C19.23 15 19 15.23
            19 15.5V16.5C19 16.77 19.23 17 19.5 17H20.5C20.77 17 21 16.77 21 16.5V15.5ZM9 5V9H5V5H9ZM9 3H5C3.9 3
            3 3.9 3 5V9C3 10.1 3.9 11 5 11H9C10.1 11 11 10.1 11 9V5C11 3.9 10.1 3 9 3ZM9 15V19H5V15H9ZM9 13H5C3.9
            13 3 13.9 3 15V19C3 20.1 3.9 21 5 21H9C10.1 21 11 20.1 11 19V15C11 13.9 10.1 13 9 13Z`}
        />
    </SvgIcon>
)

QRCodeIcon.defaultProps = defaultProps

export { QRCodeIcon }
